import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { logbaseService } from '../../services/logbase.service';
import { environment } from '../../../environments/environment';

export interface WebTableData {
  fileType: string;
  fileName: string;
  status: string;
  uploadedBy: string;
  uploadedDate: any;
}

@Component({
  selector: 'app-kkupload',
  templateUrl: './kkupload.component.html',
  styleUrls: ['./kkupload.component.scss']
})
export class KkuploadComponent implements OnInit {
  @ViewChild('kkfileUpload') kkfileUpload: ElementRef;
  file: File= null;
  tableKKDataSource: WebTableData[] = [];
  saas_uri=environment.excel_upload_saas;
  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef, private logbaseService: logbaseService,
    private spinner: NgxSpinnerService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.spinner.show();
    this.getUploadedDetails();
  }
  onFileChange(event) {
    this.file = event.target.files[0];
  }
  getUploadedDetails() {
    this.logbaseService.getFilesData('package').subscribe( result => {
      console.log(result);
      this.tableKKDataSource = result.response;
      this.spinner.hide();
    });
  }

  onCancel(){
    this.reset();
  }
  onKKUpload() {

    if (!this.file) {

      this.snackBar.open('Please Upload a File' , 'Ok', {
      
      duration: 3000,
      
      });
      
      return;
      
      }

    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const formdata = new FormData();
    formdata.append('kkFile', this.file);

    this.spinner.show();
    var responseArray: any = [];
    this.logbaseService.kkUploadData(formdata, currentUser).subscribe(result => {
      var responseData = result;
      responseArray = responseData.response;
      responseArray.forEach(response => {
        var tempResponseHolder: any = response;
        this.tableKKDataSource.push({
          fileType: tempResponseHolder.fileType,
          fileName: tempResponseHolder.fileName,
          status: tempResponseHolder.status,
          uploadedBy: tempResponseHolder.uploadedBy,
          uploadedDate: tempResponseHolder.uploadedDate,
        });
      });
      console.log(JSON.stringify(this.tableKKDataSource));
      this.spinner.hide();
    });
    this.reset();
  }
  reset() {
    console.log(this.kkfileUpload.nativeElement.files);
    this.kkfileUpload.nativeElement.value = '';
    console.log(this.kkfileUpload.nativeElement.files);
  }
  getStatus(element:string){

    if(null!=element && element!=undefined && element.toUpperCase().includes('SUCCESS')){
      return "UPLOAD SUCCESS";
    }
    else if(null!=element && element!=undefined && element.toUpperCase().includes('FAIL')){
      return "UPLOAD FAILED";
    }
    else{
      return element;
    }

  }
}
